import React, { Component } from 'react'
import LazyLoad from 'react-lazyload'

import { Loader } from 'semantic-ui-react'
import { findImage } from './utils'

class ArticleImage extends Component {

  loadImage (key, image) {
    return (
      <LazyLoad key={key} overflow={true} scroll={false}
        placeholder={<Loader active size='small' />}>
          <img alt='' src={image.url || ''} />
      </LazyLoad>
    )
  }

  render () {
    const { topicle, with_long_caption=false, with_viewport=true, with_urn_and_version_info=false } = this.props
    const media_groups = topicle.media_groups || topicle.featureimage || topicle.images || topicle.associations
    let image = findImage(media_groups, {medium: 'image'})
    image = image || findImage(media_groups, {medium: 'graphic'})

    if (!image) {
      return null
    }

    if (with_viewport) {
      return (
        <aside className='images'>
          <figure>
            <div className='viewport'>
              {this.loadImage(topicle.id, image)}
            </div>
            <figcaption>{image.title || ''}<span className="fotocredit">{ image.creditline ? (<span className="foto"></span>) : ''}{ image.creditline || ''}</span></figcaption>
            {with_long_caption ? (<figcaption className='long-caption'>{image.description || ''}</figcaption>) : ''}
          </figure>
        </aside>)
    } else {
      return (
        <aside className='images'>
          <figure>
            {this.loadImage(topicle.id, image)}
            <figcaption>{image.title || ''}</figcaption>
            {with_long_caption ? (<figcaption className='long-caption'>{image.description || ''}</figcaption>) : ''}
            {with_urn_and_version_info ? (
            <figcaption className='urn-and-version-info'>
              <dl>
                <dt>urn</dt><dd>{ topicle.urn || topicle.uri }</dd>
                <dt>version</dt><dd>{ topicle.version }</dd>
                <dt>version_created</dt><dd>{ topicle.version_created || topicle.versioncreated || topicle.updated  }</dd>
              </dl>
            </figcaption>) : ''}
          </figure>
        </aside>
      )
    }
  }
}

export default ArticleImage



// WEBPACK FOOTER //
// ./src/probish/ArticleImage.js